import { gql, useQuery } from '@apollo/client'
import { User } from '../../types'

const doc = gql`
  query FetchAdminUsers {
    fetchAdminUsers {
      id
      name
    }
  }
`

interface FetchAdminUsers {
  fetchAdminUsers: User[]
}
const useAdminUsers = () => {
  const { loading, error, data } = useQuery<FetchAdminUsers>(doc)

  let users: User[] | undefined
  if (data) {
    users = data.fetchAdminUsers
  }
  return { loading, error, data: users }
}

useAdminUsers.Query = doc
export default useAdminUsers
